import React from "react";
import styles from "./link.module.scss";
import { Link as NavLink, useLocation } from "react-router-dom";

type Props = {
  to?: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  href?: string;
  target?: string;
  onClick?: (e?: any) => void;
  className?: string;
};

function Link({ children, to, icon, href, target, onClick, className }: Props) {
  const { pathname } = useLocation();

  const active = pathname === to;

  return (
    <div className={styles.wrapper}>
      {!!href ? (
        <a
          onClick={onClick}
          className={`${styles.label} ${active ? styles.active : ""} ${
            className || ""
          }`}
          href={href}
          target={target}
        >
          {icon}
          {children}
        </a>
      ) : (
        <NavLink
          onClick={onClick}
          className={`${styles.label} ${active ? styles.active : ""} ${
            className || ""
          }`}
          to={to || ""}
        >
          {icon}
          {children}
        </NavLink>
      )}
    </div>
  );
}

export default Link;
